import httpClient from "../api/httpClient";
import _ from "lodash";
import { fetchWrapper } from "../utils/helper";

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    error: "",
    success: "",
  },
  mutations: {
    setState(state, { path, value }) {
      _.set(state, path, value);
    },
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetchTrafficSources({ commit }) {
      return fetchWrapper(async () => {
        const { data } = await httpClient.get("/traffic-sources");
        commit("setState", {
          path: "list",
          value: data.map(item => {
            if (item.source === 0) return { ...item, name: "Other" };

            return item;
          }),
        });
      }, commit, [], { updateFunctionName: "setState" });
    },
  },
};
